export function getProp(obj, propName) {
  var parts = [propName];

  for (var i = 0; i < parts.length; i++) {
    obj = obj[parts[i]];
  }
  return obj;
}
